import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Badge, Button } from 'reactstrap';
import * as Icon from 'react-feather';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import {
  setCreatePaymentMethodModalData,
  setEditPaymentMethodModalData,
  setIsCreatePaymentMethodModalOpen,
  setIsEditPaymentMethodModalOpen,
  setIsListPaymentMethodsModalOpen,
} from '../../../../redux/modal/modal.actions';
import PropTypes from 'prop-types';
import RemoveConfirmationModal from '../remove-confirmation/remove-confirmation.modal';
import { fetchPaymentMethods } from '../../../../redux/me/me.actions';
import { setPaymentMethodDefault } from '../../../../utility/sb-api/sb-api.service';
import Empty from '../../../../views/errors/empty.component';
import { getPaymentMethodDetails } from '../../../../utility/util/util.service';
import LazyImage from '../../lazyload/lazy-image/lazy-image.component';
import { removePaymentMethod } from './list-payment-methods.service';
import classnames from 'classnames';
import { notification } from '../../../../utility/notification/notification.service';
import { createSetup } from './list-payment-methods.service';
import { setCreatePaymentMethodClientSecret } from '../../../../redux/me/me.actions';

const ListPaymentMethodsModal = ({
  isOpen,
  data,
  paymentMethods,
  intl,

  setIsListPaymentMethodsModalOpen,
  fetchPaymentMethods,
  setIsCreatePaymentMethodModalOpen,
  setCreatePaymentMethodClientSecret,
  setCreatePaymentMethodModalData,
}) => {
  const [removePaymentMethodId, setRemovePaymentMethodId] = useState(null);

  const closeModal = () => setIsListPaymentMethodsModalOpen(false);

  return (
    <>
      <ModalSheet
        isOpen={isOpen}
        closeModal={closeModal}
        title={intl.formatMessage({ id: 'paymentMethodsTitle' })}
        footer={
          <div className="align-content-center">
            <Button
              color="primary"
              className="w-100"
              onClick={() => {
                createSetup(setCreatePaymentMethodClientSecret).then((res) => {
                  setCreatePaymentMethodClientSecret(res.clientSecret);
                  setCreatePaymentMethodModalData({
                    onSuccess: () => setIsListPaymentMethodsModalOpen(true),
                  });
                  setIsCreatePaymentMethodModalOpen(true);
                });
              }}
            >
              <FormattedMessage id="createNewPaymentMethodTitle" />
            </Button>
          </div>
        }
      >
        <div className="px-1">
          {paymentMethods?.length > 0 ? (
            paymentMethods.map((paymentMethod, index) => {
              const { iconSrc, suffix } = getPaymentMethodDetails(
                paymentMethod,
              );

              const onRemoveClick = () => {
                closeModal();
                setRemovePaymentMethodId(paymentMethod.id);
              };
              const onDefaultClick = () => {
                setPaymentMethodDefault(paymentMethod.id).then(() => {
                  notification('success', 'setDefaultPaymentMethodSuccess');
                  fetchPaymentMethods();
                });
              };

              return (
                <>
                  <div
                    key={index}
                    className="d-flex align-items-center justify-content-between px-1"
                  >
                    <LazyImage
                      src={iconSrc}
                      className="thumbnail-h35"
                      placeholderContainerClassNames="thumbnail-h35"
                      placeholderClassNames="thumbnail-h35"
                    />
                    <span>{suffix}</span>
                    <div className="d-flex justify-content-center align-items-center">
                      <span
                        onClick={
                          !paymentMethod.isDefault
                            ? onDefaultClick
                            : () => undefined
                        }
                        className="mr-2"
                      >
                        <Badge
                          color="light-warning"
                          className={classnames({
                            opacity4: !paymentMethod.isDefault,
                          })}
                        >
                          <FormattedMessage id="default" />
                        </Badge>
                      </span>
                      <span onClick={onRemoveClick}>
                        <Icon.Trash2 size={22} className="danger" />
                      </span>
                    </div>
                  </div>
                  {index < paymentMethods.length - 1 && <hr />}
                </>
              );
            })
          ) : (
            <Empty className="my-2" titleId="emptyPaymentMethodsListTitle" />
          )}
        </div>
      </ModalSheet>
      <RemoveConfirmationModal
        isOpen={!!removePaymentMethodId}
        closeModal={() => setRemovePaymentMethodId(null)}
        titleId="confirm"
        messageId="removePaymentMethodConfirmation"
        handleRemoval={() =>
          removePaymentMethod(removePaymentMethodId)
            .then(fetchPaymentMethods)
            .then(() => setIsListPaymentMethodsModalOpen(true))
        }
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isListPaymentMethodsModalOpen,
  data: state.modals.listPaymentMethodsModalData,
  paymentMethods: state.me.paymentMethods,
});

export default connect(mapStateToProps, {
  setIsListPaymentMethodsModalOpen,
  setIsEditPaymentMethodModalOpen,
  setEditPaymentMethodModalData,
  fetchPaymentMethods,
  setIsCreatePaymentMethodModalOpen,
  setCreatePaymentMethodModalData,
  setCreatePaymentMethodClientSecret,
})(injectIntl(ListPaymentMethodsModal));
